import { createResourceStore } from "@/lib/resource";
import type { StockBatch } from "./StockBatch";
import type { FinanceAccount } from "./FinanceAccount";

import type { User } from "./User";

import type { Shop } from "./Shop";

export interface StockTransfer {
  id: string;

  // Stock batches
  sender_batch_id: string;
  receiver_batch_id: string;

  // Optional finance accounts
  sender_finance_account_id?: string | null;
  receiver_finance_account_id?: string | null;

  // Quantity and reason
  quantity: number;
  reason?: string | null;

  // Status
  status: "pending" | "approved" | "completed" | "cancelled";
  type: string;

  // Users
  created_by: string;
  approved_by?: string | null;

  // Timestamps
  created_at: string;
  updated_at: string;

  // Optional loaded relations (frontend can type these as needed)
  sender_batch: StockBatch;
  receiver_batch: StockBatch;
  receiver_shop: Shop;
  sender_shop: Shop;
  sender_finance_account: FinanceAccount;
  receiver_finance_account: FinanceAccount;
  creator: User;
  approver: User;
}

export const useStockTransfer =
  createResourceStore<StockTransfer>("stock-transfers");
